import React, { ReactElement } from 'react';
import { Button, Icon } from '../../../../../../../components/CiscoUi';
import styles from './SrvTableActions.module.css';

interface SrvTableActionsProps {
  srvRecord: SrvRecord;
  onDeleteClick: (srvRecord: SrvRecord) => void;
}

export function SrvTableActions({
  onDeleteClick,
  srvRecord,
}: SrvTableActionsProps): ReactElement {
  return (
    <ul aria-label="Card actions" className={styles.root}>
      <li className={styles.action}>
        <Button
          colour="link"
          onClick={() => onDeleteClick(srvRecord)}
          data-test="srv-table-actions-delete"
        >
          <Icon name="delete" />
        </Button>
      </li>
    </ul>
  );
}
